var map = {
	"./PrepWorks-Logo": 22,
	"./PrepWorks-Logo.svg": 22,
	"./PrepWorks-Logo_300": 23,
	"./PrepWorks-Logo_300.png": 23,
	"./PrepWorks-Logo_300_Light": 24,
	"./PrepWorks-Logo_300_Light.png": 24,
	"./PrepWorks-Logo_Light": 25,
	"./PrepWorks-Logo_Light.svg": 25,
	"./PrepWorks-feature-img": 26,
	"./PrepWorks-feature-img.jpg": 26,
	"./covers/Foundation-Open-Day-Banner": 27,
	"./covers/Foundation-Open-Day-Banner.png": 27,
	"./covers/Foundation-Open-Day-Mobile": 28,
	"./covers/Foundation-Open-Day-Mobile.png": 28,
	"./covers/Live-Results-Banner": 29,
	"./covers/Live-Results-Banner.png": 29,
	"./covers/Live-Results-Mobile": 30,
	"./covers/Live-Results-Mobile.png": 30,
	"./covers/PrepWorks-Academy_Poster": 13,
	"./covers/PrepWorks-Academy_Poster.jpg": 472,
	"./covers/PrepWorks-Academy_Poster.webp": 13,
	"./covers/PrepWorks_Roadmap-to-Ivy-Leagues_Cover": 31,
	"./covers/PrepWorks_Roadmap-to-Ivy-Leagues_Cover.jpg": 31,
	"./covers/PrepWorks_Roadmap-to-Oxbridge_Cover": 32,
	"./covers/PrepWorks_Roadmap-to-Oxbridge_Cover.jpg": 32,
	"./covers/PrepWorks_Student-Testimonial_Clarissa-Teh_Poster": 14,
	"./covers/PrepWorks_Student-Testimonial_Clarissa-Teh_Poster.jpg": 473,
	"./covers/PrepWorks_Student-Testimonial_Clarissa-Teh_Poster.webp": 14,
	"./covers/PrepWorks_Student-Testimonial_Er-Hao_Poster": 15,
	"./covers/PrepWorks_Student-Testimonial_Er-Hao_Poster.jpg": 474,
	"./covers/PrepWorks_Student-Testimonial_Er-Hao_Poster.webp": 15,
	"./covers/PrepWorks_Student-Testimonial_Nurazreen_Poster": 16,
	"./covers/PrepWorks_Student-Testimonial_Nurazreen_Poster.jpg": 475,
	"./covers/PrepWorks_Student-Testimonial_Nurazreen_Poster.webp": 16,
	"./covers/PrepWorks_Student-Testimonial_Sachdev-Singh_Poster": 17,
	"./covers/PrepWorks_Student-Testimonial_Sachdev-Singh_Poster.jpg": 476,
	"./covers/PrepWorks_Student-Testimonial_Sachdev-Singh_Poster.webp": 17,
	"./covers/PrepWorks_Tutoring_Poster": 33,
	"./covers/PrepWorks_Tutoring_Poster.jpg": 33,
	"./covers/PrepWorks_University-Admissions_Poster": 34,
	"./covers/PrepWorks_University-Admissions_Poster.jpg": 34,
	"./covers/Roadmap-To-Oxbridge-Cover": 35,
	"./covers/Roadmap-To-Oxbridge-Cover.png": 35,
	"./covers/Roadmap-to-Ivy-Leagues-Cover": 36,
	"./covers/Roadmap-to-Ivy-Leagues-Cover.png": 36,
	"./covers/StarWorks-NEW-Intro-Video-Thumbnail": 37,
	"./covers/StarWorks-NEW-Intro-Video-Thumbnail.jpg": 37,
	"./covers/Tamara-Consultations-Banner": 38,
	"./covers/Tamara-Consultations-Banner.jpg": 38,
	"./covers/Tamara-Consultations-Banner_mobile": 39,
	"./covers/Tamara-Consultations-Banner_mobile.jpg": 39,
	"./covers/Virtual-Boarding-School-Fair-2024": 40,
	"./covers/Virtual-Boarding-School-Fair-2024.jpg": 40,
	"./covers/discover-your-future/discover-bg": 41,
	"./covers/discover-your-future/discover-bg.jpg": 41,
	"./covers/discover-your-future/discover-logo-1": 42,
	"./covers/discover-your-future/discover-logo-1.png": 42,
	"./covers/discover-your-future/discover-logo-10": 43,
	"./covers/discover-your-future/discover-logo-10.png": 43,
	"./covers/discover-your-future/discover-logo-11": 44,
	"./covers/discover-your-future/discover-logo-11.png": 44,
	"./covers/discover-your-future/discover-logo-2": 45,
	"./covers/discover-your-future/discover-logo-2.png": 45,
	"./covers/discover-your-future/discover-logo-3": 46,
	"./covers/discover-your-future/discover-logo-3.png": 46,
	"./covers/discover-your-future/discover-logo-4": 47,
	"./covers/discover-your-future/discover-logo-4.png": 47,
	"./covers/discover-your-future/discover-logo-5": 48,
	"./covers/discover-your-future/discover-logo-5.png": 48,
	"./covers/discover-your-future/discover-logo-6": 49,
	"./covers/discover-your-future/discover-logo-6.png": 49,
	"./covers/discover-your-future/discover-logo-7": 50,
	"./covers/discover-your-future/discover-logo-7.png": 50,
	"./covers/discover-your-future/discover-logo-8": 51,
	"./covers/discover-your-future/discover-logo-8.png": 51,
	"./covers/discover-your-future/discover-logo-9": 52,
	"./covers/discover-your-future/discover-logo-9.png": 52,
	"./covers/foundation/Foundation-Programme_banner": 53,
	"./covers/foundation/Foundation-Programme_banner.png": 53,
	"./covers/foundation/Foundation-Programme_mobile-banner": 54,
	"./covers/foundation/Foundation-Programme_mobile-banner.png": 54,
	"./covers/foundation/Kings-College-London-logo": 55,
	"./covers/foundation/Kings-College-London-logo.svg": 55,
	"./covers/foundation/Manchester-Metropolitan-University-logo": 56,
	"./covers/foundation/Manchester-Metropolitan-University-logo.svg": 56,
	"./covers/foundation/Queen-Mary-University-of-London-logo": 57,
	"./covers/foundation/Queen-Mary-University-of-London-logo.svg": 57,
	"./covers/foundation/University-of-Bath-logo": 58,
	"./covers/foundation/University-of-Bath-logo.svg": 58,
	"./covers/foundation/University-of-Birmingham-logo": 59,
	"./covers/foundation/University-of-Birmingham-logo.svg": 59,
	"./covers/foundation/University-of-Lancaster-logo": 60,
	"./covers/foundation/University-of-Lancaster-logo.svg": 60,
	"./covers/foundation/University-of-Manchester-logo": 61,
	"./covers/foundation/University-of-Manchester-logo.svg": 61,
	"./covers/foundation/University-of-Southampton-logo": 62,
	"./covers/foundation/University-of-Southampton-logo.svg": 62,
	"./covers/foundation/University-of-Surrey-logo": 63,
	"./covers/foundation/University-of-Surrey-logo.svg": 63,
	"./covers/foundation/University-of-York-logo": 64,
	"./covers/foundation/University-of-York-logo.svg": 64,
	"./covers/foundation/about-prepworks-foundation": 65,
	"./covers/foundation/about-prepworks-foundation.jpg": 65,
	"./covers/foundation/cambridge-students": 66,
	"./covers/foundation/cambridge-students.jpg": 66,
	"./covers/foundation/our-teachers-01": 67,
	"./covers/foundation/our-teachers-01.jpg": 67,
	"./covers/foundation/our-teachers-02": 68,
	"./covers/foundation/our-teachers-02.jpg": 68,
	"./covers/foundation/st-andrews-college-logo": 69,
	"./covers/foundation/st-andrews-college-logo.png": 69,
	"./covers/prepworks-new-registration": 70,
	"./covers/prepworks-new-registration.jpg": 70,
	"./covers/starworks-weekly-sept24-banner": 71,
	"./covers/starworks-weekly-sept24-banner.png": 71,
	"./covers/starworks-weekly-sept24-bg": 72,
	"./covers/starworks-weekly-sept24-bg-mobile": 73,
	"./covers/starworks-weekly-sept24-bg-mobile.png": 73,
	"./covers/starworks-weekly-sept24-bg.png": 72,
	"./covers/starworks-weekly-sept24-mobile": 74,
	"./covers/starworks-weekly-sept24-mobile.png": 74,
	"./covers/sw-thumb-01": 75,
	"./covers/sw-thumb-01.jpg": 75,
	"./covers/sw-thumb-02": 76,
	"./covers/sw-thumb-02.jpg": 76,
	"./covers/sw-thumb-03": 77,
	"./covers/sw-thumb-03.jpg": 77,
	"./covers/sw-thumb-04": 78,
	"./covers/sw-thumb-04.jpg": 78,
	"./covers/sw-thumb-05": 79,
	"./covers/sw-thumb-05.jpg": 79,
	"./covers/sw-thumb-06": 80,
	"./covers/sw-thumb-06.jpg": 80,
	"./covers/top-uk-boarding-schools-poster": 81,
	"./covers/top-uk-boarding-schools-poster.jpg": 81,
	"./hsbc-logo-light": 82,
	"./hsbc-logo-light.svg": 82,
	"./icons/academic-development": 83,
	"./icons/academic-development.svg": 83,
	"./icons/academic-development_01": 84,
	"./icons/academic-development_01.svg": 84,
	"./icons/academic-development_02": 85,
	"./icons/academic-development_02.svg": 85,
	"./icons/academic-development_03": 86,
	"./icons/academic-development_03.svg": 86,
	"./icons/academic-development_04": 87,
	"./icons/academic-development_04.svg": 87,
	"./icons/academic-development_05": 88,
	"./icons/academic-development_05.svg": 88,
	"./icons/academy-addon": 89,
	"./icons/academy-addon.svg": 89,
	"./icons/academy-bahasa": 90,
	"./icons/academy-bahasa.svg": 90,
	"./icons/academy-bundle": 91,
	"./icons/academy-bundle.svg": 91,
	"./icons/academy-english": 92,
	"./icons/academy-english.svg": 92,
	"./icons/academy-humanities": 93,
	"./icons/academy-humanities.svg": 93,
	"./icons/academy-mandarin": 94,
	"./icons/academy-mandarin.svg": 94,
	"./icons/academy-maths": 95,
	"./icons/academy-maths.svg": 95,
	"./icons/academy-science": 96,
	"./icons/academy-science.svg": 96,
	"./icons/admissions-guidance": 97,
	"./icons/admissions-guidance.svg": 97,
	"./icons/certificate": 98,
	"./icons/certificate.svg": 98,
	"./icons/character-development": 99,
	"./icons/character-development.svg": 99,
	"./icons/character-development_01": 100,
	"./icons/character-development_01.svg": 100,
	"./icons/character-development_02": 101,
	"./icons/character-development_02.svg": 101,
	"./icons/consultation-01": 102,
	"./icons/consultation-01.svg": 102,
	"./icons/consultation-02": 103,
	"./icons/consultation-02.svg": 103,
	"./icons/consultation-03": 104,
	"./icons/consultation-03.svg": 104,
	"./icons/consultation-04": 105,
	"./icons/consultation-04.svg": 105,
	"./icons/consultation-05": 106,
	"./icons/consultation-05.svg": 106,
	"./icons/consultation-06": 107,
	"./icons/consultation-06.svg": 107,
	"./icons/exam-preparation": 108,
	"./icons/exam-preparation.svg": 108,
	"./icons/flat-color-square-email": 109,
	"./icons/flat-color-square-email.png": 109,
	"./icons/flat-color-square-facebook": 110,
	"./icons/flat-color-square-facebook.png": 110,
	"./icons/flat-color-square-instagram": 111,
	"./icons/flat-color-square-instagram.png": 111,
	"./icons/flat-color-square-website": 112,
	"./icons/flat-color-square-website.png": 112,
	"./icons/flat-color-square-youtube": 113,
	"./icons/flat-color-square-youtube.png": 113,
	"./icons/google-maps": 114,
	"./icons/google-maps.svg": 114,
	"./icons/icon-admissions": 115,
	"./icons/icon-admissions.svg": 115,
	"./icons/icon-boost": 116,
	"./icons/icon-boost.svg": 116,
	"./icons/icon-certificate": 117,
	"./icons/icon-certificate.svg": 117,
	"./icons/icon-mentorship": 118,
	"./icons/icon-mentorship.svg": 118,
	"./icons/icon-offer-letter": 119,
	"./icons/icon-offer-letter.svg": 119,
	"./icons/icon-tutoring": 120,
	"./icons/icon-tutoring.svg": 120,
	"./icons/icon-tutors": 121,
	"./icons/icon-tutors.svg": 121,
	"./icons/institution": 122,
	"./icons/institution.svg": 122,
	"./icons/interview-preparation": 123,
	"./icons/interview-preparation.svg": 123,
	"./icons/marking": 124,
	"./icons/marking.svg": 124,
	"./icons/medicine-admissions": 125,
	"./icons/medicine-admissions.svg": 125,
	"./icons/personal-statement": 126,
	"./icons/personal-statement.svg": 126,
	"./icons/skills-development": 127,
	"./icons/skills-development.svg": 127,
	"./icons/skills-development_01": 128,
	"./icons/skills-development_01.svg": 128,
	"./icons/skills-development_02": 129,
	"./icons/skills-development_02.svg": 129,
	"./icons/sw-care": 130,
	"./icons/sw-care.svg": 130,
	"./icons/sw-comm": 131,
	"./icons/sw-comm.svg": 131,
	"./icons/sw-ct": 132,
	"./icons/sw-ct.svg": 132,
	"./icons/sw-eng": 133,
	"./icons/sw-eng.svg": 133,
	"./icons/sw-gk": 134,
	"./icons/sw-gk.svg": 134,
	"./icons/sw-math": 135,
	"./icons/sw-math.svg": 135,
	"./icons/sw-pt1-icon": 136,
	"./icons/sw-pt1-icon.svg": 136,
	"./icons/sw-pt2-icon": 137,
	"./icons/sw-pt2-icon.svg": 137,
	"./icons/sw-pt3-icon": 138,
	"./icons/sw-pt3-icon.svg": 138,
	"./icons/tutoring-package-1": 139,
	"./icons/tutoring-package-1.svg": 139,
	"./icons/tutoring-package-2": 140,
	"./icons/tutoring-package-2.svg": 140,
	"./icons/uk-professor": 141,
	"./icons/uk-professor.svg": 141,
	"./icons/us-professor": 142,
	"./icons/us-professor.svg": 142,
	"./illustrations/Icon-Admissions": 143,
	"./illustrations/Icon-Admissions.svg": 143,
	"./illustrations/Icon-Applicants": 144,
	"./illustrations/Icon-Applicants.svg": 144,
	"./illustrations/Icon-Mentorship": 145,
	"./illustrations/Icon-Mentorship.svg": 145,
	"./illustrations/Icon-StarWorks": 146,
	"./illustrations/Icon-StarWorks.svg": 146,
	"./illustrations/Icon-Student": 147,
	"./illustrations/Icon-Student.svg": 147,
	"./illustrations/Icon-Students": 148,
	"./illustrations/Icon-Students.svg": 148,
	"./illustrations/Icon-Tutoring": 149,
	"./illustrations/Icon-Tutoring.svg": 149,
	"./illustrations/StarWorks-Hero-BG": 150,
	"./illustrations/StarWorks-Hero-BG.jpg": 150,
	"./illustrations/StarWorks-Hero_02_Arm": 151,
	"./illustrations/StarWorks-Hero_02_Arm.png": 151,
	"./illustrations/StarWorks-Hero_02_Character": 152,
	"./illustrations/StarWorks-Hero_02_Character.png": 152,
	"./illustrations/StarWorks-Hero_02_Glass": 153,
	"./illustrations/StarWorks-Hero_02_Glass.png": 153,
	"./illustrations/StarWorks-Hero_02_Hand": 154,
	"./illustrations/StarWorks-Hero_02_Hand.png": 154,
	"./illustrations/StarWorks-Hero_02_Rocket": 155,
	"./illustrations/StarWorks-Hero_02_Rocket.png": 155,
	"./illustrations/StarWorks-Hero_02_Trail-01": 156,
	"./illustrations/StarWorks-Hero_02_Trail-01.png": 156,
	"./illustrations/StarWorks-Hero_02_Trail-02": 157,
	"./illustrations/StarWorks-Hero_02_Trail-02.png": 157,
	"./illustrations/StarWorks-Hero_02_Trail-03": 158,
	"./illustrations/StarWorks-Hero_02_Trail-03.png": 158,
	"./illustrations/StarWorks-Hero_Frame01": 159,
	"./illustrations/StarWorks-Hero_Frame01.png": 159,
	"./illustrations/StarWorks-Hero_Frame02": 160,
	"./illustrations/StarWorks-Hero_Frame02.png": 160,
	"./illustrations/StarWorks-Hero_Frame03": 161,
	"./illustrations/StarWorks-Hero_Frame03.png": 161,
	"./illustrations/StarWorks-Hero_Frame04": 162,
	"./illustrations/StarWorks-Hero_Frame04.png": 162,
	"./illustrations/StarWorks-Hero_Frame05": 163,
	"./illustrations/StarWorks-Hero_Frame05.png": 163,
	"./illustrations/StarWorks-Hero_Frame06": 164,
	"./illustrations/StarWorks-Hero_Frame06.png": 164,
	"./illustrations/StarWorks-Hero_Frame07": 165,
	"./illustrations/StarWorks-Hero_Frame07.png": 165,
	"./illustrations/StarWorks-Student-01": 166,
	"./illustrations/StarWorks-Student-01.png": 166,
	"./illustrations/StarWorks-Student-01_Thought-Bubble": 167,
	"./illustrations/StarWorks-Student-01_Thought-Bubble.png": 167,
	"./illustrations/academic-coaching": 168,
	"./illustrations/academic-coaching.svg": 168,
	"./illustrations/bg-noise": 169,
	"./illustrations/bg-noise.jpg": 169,
	"./illustrations/boarding-school": 170,
	"./illustrations/boarding-school.svg": 170,
	"./illustrations/character-development-01": 171,
	"./illustrations/character-development-01.svg": 171,
	"./illustrations/character-development-02": 172,
	"./illustrations/character-development-02.svg": 172,
	"./illustrations/enrichment-programme": 173,
	"./illustrations/enrichment-programme-2": 174,
	"./illustrations/enrichment-programme-2.svg": 174,
	"./illustrations/enrichment-programme.svg": 173,
	"./illustrations/get-into-oxbridge-and-ivy-leagues": 175,
	"./illustrations/get-into-oxbridge-and-ivy-leagues.svg": 175,
	"./illustrations/gude-2022-08-17.log": 477,
	"./illustrations/mentorship-programme": 176,
	"./illustrations/mentorship-programme.svg": 176,
	"./illustrations/online-tutoring-01": 177,
	"./illustrations/online-tutoring-01.svg": 177,
	"./illustrations/online-tutoring-02": 178,
	"./illustrations/online-tutoring-02.svg": 178,
	"./illustrations/path-to-success": 179,
	"./illustrations/path-to-success.svg": 179,
	"./illustrations/pre-university-tutoring": 180,
	"./illustrations/pre-university-tutoring.svg": 180,
	"./illustrations/prepworks-academy": 181,
	"./illustrations/prepworks-academy.svg": 181,
	"./illustrations/prepworks-growth": 182,
	"./illustrations/prepworks-growth.svg": 182,
	"./illustrations/prepworks-path-to-success": 183,
	"./illustrations/prepworks-path-to-success.svg": 183,
	"./illustrations/prepworks-services": 184,
	"./illustrations/prepworks-services.svg": 184,
	"./illustrations/skills-development-01": 185,
	"./illustrations/skills-development-01.svg": 185,
	"./illustrations/skills-development-02": 186,
	"./illustrations/skills-development-02.svg": 186,
	"./illustrations/starworks-diagram": 187,
	"./illustrations/starworks-diagram.svg": 187,
	"./illustrations/starworks-star-light": 188,
	"./illustrations/starworks-star-light.svg": 188,
	"./illustrations/starworks-star-warning": 189,
	"./illustrations/starworks-star-warning.svg": 189,
	"./illustrations/starworks-student-01": 190,
	"./illustrations/starworks-student-01.svg": 190,
	"./illustrations/top-uk-schools": 191,
	"./illustrations/top-uk-schools.svg": 191,
	"./illustrations/top-us-schools": 192,
	"./illustrations/top-us-schools.svg": 192,
	"./illustrations/tutoring": 193,
	"./illustrations/tutoring.svg": 193,
	"./illustrations/united-kingdom": 194,
	"./illustrations/united-kingdom.svg": 194,
	"./illustrations/united-states": 195,
	"./illustrations/united-states.svg": 195,
	"./illustrations/university-admissions": 196,
	"./illustrations/university-admissions.svg": 196,
	"./illustrations/wave-blue-1": 197,
	"./illustrations/wave-blue-1.svg": 197,
	"./illustrations/wave-blue-2": 198,
	"./illustrations/wave-blue-2.svg": 198,
	"./illustrations/wave-light-1": 199,
	"./illustrations/wave-light-1.svg": 199,
	"./illustrations/wave-light-2": 200,
	"./illustrations/wave-light-2.svg": 200,
	"./illustrations/wave-light-3": 201,
	"./illustrations/wave-light-3.svg": 201,
	"./illustrations/wave-starworks-1": 202,
	"./illustrations/wave-starworks-1.svg": 202,
	"./illustrations/wave-starworks-2": 203,
	"./illustrations/wave-starworks-2.svg": 203,
	"./illustrations/wave-starworks-3": 204,
	"./illustrations/wave-starworks-3.svg": 204,
	"./illustrations/wave-white-1": 205,
	"./illustrations/wave-white-1.svg": 205,
	"./illustrations/wave-white-2": 206,
	"./illustrations/wave-white-2.svg": 206,
	"./illustrations/wave-white-3": 207,
	"./illustrations/wave-white-3.svg": 207,
	"./illustrations/your-one-stop-partner": 208,
	"./illustrations/your-one-stop-partner.svg": 208,
	"./logos/Asclepius-Consultancy_logo": 209,
	"./logos/Asclepius-Consultancy_logo.jpg": 209,
	"./logos/AstroAwani-logo": 210,
	"./logos/AstroAwani-logo.png": 210,
	"./logos/BFM_logo": 211,
	"./logos/BFM_logo.png": 211,
	"./logos/Brown-University": 212,
	"./logos/Brown-University.svg": 212,
	"./logos/Canterbury-University": 213,
	"./logos/Canterbury-University.svg": 213,
	"./logos/Cornell-University": 214,
	"./logos/Cornell-University.svg": 214,
	"./logos/DeMontfort": 215,
	"./logos/DeMontfort.svg": 215,
	"./logos/Durham-University": 216,
	"./logos/Durham-University.svg": 216,
	"./logos/HELP-University": 217,
	"./logos/HELP-University.svg": 217,
	"./logos/Harvard-University": 218,
	"./logos/Harvard-University.svg": 218,
	"./logos/Imperial-College-London": 219,
	"./logos/Imperial-College-London.svg": 219,
	"./logos/Institute-of-Teacher-Education": 220,
	"./logos/Institute-of-Teacher-Education.svg": 220,
	"./logos/International-Business-Times_logo": 221,
	"./logos/International-Business-Times_logo.svg": 221,
	"./logos/Kings-College-London": 222,
	"./logos/Kings-College-London.svg": 222,
	"./logos/London-School-of-Economics": 223,
	"./logos/London-School-of-Economics.svg": 223,
	"./logos/MARA-College-of-Higher-Education": 224,
	"./logos/MARA-College-of-Higher-Education.svg": 224,
	"./logos/MARA-University-of-Technology": 225,
	"./logos/MARA-University-of-Technology.svg": 225,
	"./logos/Malaysia-Kini_logo": 226,
	"./logos/Malaysia-Kini_logo.svg": 226,
	"./logos/Management-and-Science-University": 227,
	"./logos/Management-and-Science-University.svg": 227,
	"./logos/Monash-University": 228,
	"./logos/Monash-University.svg": 228,
	"./logos/Mount-Carmel-College": 229,
	"./logos/Mount-Carmel-College.svg": 229,
	"./logos/National-University-of-Singapore": 230,
	"./logos/National-University-of-Singapore.svg": 230,
	"./logos/Princeton-University": 231,
	"./logos/Princeton-University.svg": 231,
	"./logos/Queen-Mary-University": 232,
	"./logos/Queen-Mary-University.svg": 232,
	"./logos/RMIT-University": 233,
	"./logos/RMIT-University.svg": 233,
	"./logos/Royal-Holloway-University-of-London": 234,
	"./logos/Royal-Holloway-University-of-London.svg": 234,
	"./logos/Saint-Louis-University": 235,
	"./logos/Saint-Louis-University.svg": 235,
	"./logos/Sidney-Sussex-College": 236,
	"./logos/Sidney-Sussex-College.svg": 236,
	"./logos/Singapore-Institute-of-Management": 237,
	"./logos/Singapore-Institute-of-Management.svg": 237,
	"./logos/Stanford-University": 238,
	"./logos/Stanford-University.svg": 238,
	"./logos/Sunway-University": 239,
	"./logos/Sunway-University.svg": 239,
	"./logos/Tatler-logo": 240,
	"./logos/Tatler-logo.svg": 240,
	"./logos/Temasek-Polytechnic": 241,
	"./logos/Temasek-Polytechnic.svg": 241,
	"./logos/TheEdge-logo": 242,
	"./logos/TheEdge-logo.png": 242,
	"./logos/TheStar-logo": 243,
	"./logos/TheStar-logo.svg": 243,
	"./logos/Tunku-Abdul-Rahman-University": 244,
	"./logos/Tunku-Abdul-Rahman-University.svg": 244,
	"./logos/Universiti-Tenaga-Nasional": 245,
	"./logos/Universiti-Tenaga-Nasional.svg": 245,
	"./logos/University-College-London": 246,
	"./logos/University-College-London.svg": 246,
	"./logos/University-of-Antwerp": 247,
	"./logos/University-of-Antwerp.svg": 247,
	"./logos/University-of-Bath": 248,
	"./logos/University-of-Bath.svg": 248,
	"./logos/University-of-Birmingham": 249,
	"./logos/University-of-Birmingham.svg": 249,
	"./logos/University-of-Bristol": 250,
	"./logos/University-of-Bristol.svg": 250,
	"./logos/University-of-Cambridge": 251,
	"./logos/University-of-Cambridge.svg": 251,
	"./logos/University-of-Columbia": 252,
	"./logos/University-of-Columbia.svg": 252,
	"./logos/University-of-Exeter": 253,
	"./logos/University-of-Exeter.svg": 253,
	"./logos/University-of-London": 254,
	"./logos/University-of-London.svg": 254,
	"./logos/University-of-Malaya": 255,
	"./logos/University-of-Malaya.svg": 255,
	"./logos/University-of-Manchester": 256,
	"./logos/University-of-Manchester.svg": 256,
	"./logos/University-of-Melbourne": 257,
	"./logos/University-of-Melbourne.svg": 257,
	"./logos/University-of-Nottingham": 258,
	"./logos/University-of-Nottingham.svg": 258,
	"./logos/University-of-Oxford": 259,
	"./logos/University-of-Oxford.svg": 259,
	"./logos/University-of-Pennsylvania": 260,
	"./logos/University-of-Pennsylvania.svg": 260,
	"./logos/University-of-Sheffield": 261,
	"./logos/University-of-Sheffield.svg": 261,
	"./logos/University-of-Southampton": 262,
	"./logos/University-of-Southampton.svg": 262,
	"./logos/University-of-Sydney": 263,
	"./logos/University-of-Sydney.svg": 263,
	"./logos/University-of-Toronto-Trinity-College": 264,
	"./logos/University-of-Toronto-Trinity-College.svg": 264,
	"./logos/University-of-Warwick": 265,
	"./logos/University-of-Warwick.svg": 265,
	"./logos/Yahoo-Finance-logo": 266,
	"./logos/Yahoo-Finance-logo.svg": 266,
	"./pathway_illustrations/ACCOUNTING-FINANCE": 267,
	"./pathway_illustrations/ACCOUNTING-FINANCE.png": 267,
	"./pathway_illustrations/ACTUARIAL SCIENCE": 268,
	"./pathway_illustrations/ACTUARIAL SCIENCE.png": 268,
	"./pathway_illustrations/AERONAUTICAL ENGINEERING": 269,
	"./pathway_illustrations/AERONAUTICAL ENGINEERING.png": 269,
	"./pathway_illustrations/AGRICULTURE": 270,
	"./pathway_illustrations/AGRICULTURE.png": 270,
	"./pathway_illustrations/ARCHITECTURE": 271,
	"./pathway_illustrations/ARCHITECTURE.png": 271,
	"./pathway_illustrations/ASTROPHYSICS-ASTRONOMY": 272,
	"./pathway_illustrations/ASTROPHYSICS-ASTRONOMY.png": 272,
	"./pathway_illustrations/BIOCHEMISTRY": 273,
	"./pathway_illustrations/BIOCHEMISTRY.png": 273,
	"./pathway_illustrations/BIOLOGICAL ENGINEERING-BIOMEDICAL ENGINEERING": 274,
	"./pathway_illustrations/BIOLOGICAL ENGINEERING-BIOMEDICAL ENGINEERING.png": 274,
	"./pathway_illustrations/BIOLOGY": 275,
	"./pathway_illustrations/BIOLOGY.png": 275,
	"./pathway_illustrations/BIOMEDICAL SCIENCES": 276,
	"./pathway_illustrations/BIOMEDICAL SCIENCES.png": 276,
	"./pathway_illustrations/BIOPHYSICS": 277,
	"./pathway_illustrations/BIOPHYSICS.png": 277,
	"./pathway_illustrations/CHEMICAL ENGINEERING": 278,
	"./pathway_illustrations/CHEMICAL ENGINEERING.png": 278,
	"./pathway_illustrations/CHEMISTRY": 279,
	"./pathway_illustrations/CHEMISTRY.png": 279,
	"./pathway_illustrations/CIVIL ENGINEERING": 280,
	"./pathway_illustrations/CIVIL ENGINEERING.png": 280,
	"./pathway_illustrations/CLASSICS-ARCHAEOLOGY": 281,
	"./pathway_illustrations/CLASSICS-ARCHAEOLOGY.png": 281,
	"./pathway_illustrations/COMPUTER SCIENCE-SOFTWARE ENGINEERING": 282,
	"./pathway_illustrations/COMPUTER SCIENCE-SOFTWARE ENGINEERING.png": 282,
	"./pathway_illustrations/CULTURAL STUDIES": 283,
	"./pathway_illustrations/CULTURAL STUDIES.png": 283,
	"./pathway_illustrations/DATA SCIENCE": 284,
	"./pathway_illustrations/DATA SCIENCE.png": 284,
	"./pathway_illustrations/DENTISTRY": 285,
	"./pathway_illustrations/DENTISTRY.png": 285,
	"./pathway_illustrations/DIGITAL ART": 286,
	"./pathway_illustrations/DIGITAL ART.png": 286,
	"./pathway_illustrations/ECONOMICS": 287,
	"./pathway_illustrations/ECONOMICS.png": 287,
	"./pathway_illustrations/EDUCATION": 288,
	"./pathway_illustrations/EDUCATION.png": 288,
	"./pathway_illustrations/ELECTRICAL-ELECTRONIC ENGINEERING": 289,
	"./pathway_illustrations/ELECTRICAL-ELECTRONIC ENGINEERING.png": 289,
	"./pathway_illustrations/ENGLISH LITERATURE": 290,
	"./pathway_illustrations/ENGLISH LITERATURE.png": 290,
	"./pathway_illustrations/FILM STUDIES-MEDIA STUDIES-CREATIVE ARTS": 291,
	"./pathway_illustrations/FILM STUDIES-MEDIA STUDIES-CREATIVE ARTS.png": 291,
	"./pathway_illustrations/FINE ART": 292,
	"./pathway_illustrations/FINE ART.png": 292,
	"./pathway_illustrations/GEOGRAPHY": 293,
	"./pathway_illustrations/GEOGRAPHY.png": 293,
	"./pathway_illustrations/GEOLOGY-EARTH SCIENCES": 294,
	"./pathway_illustrations/GEOLOGY-EARTH SCIENCES.png": 294,
	"./pathway_illustrations/HISTORY": 295,
	"./pathway_illustrations/HISTORY OF ART": 296,
	"./pathway_illustrations/HISTORY OF ART.png": 296,
	"./pathway_illustrations/HISTORY.png": 295,
	"./pathway_illustrations/HUMAN SCIENCES-ANTHROPOLOGY": 297,
	"./pathway_illustrations/HUMAN SCIENCES-ANTHROPOLOGY.png": 297,
	"./pathway_illustrations/JOURNALISM": 298,
	"./pathway_illustrations/JOURNALISM.png": 298,
	"./pathway_illustrations/LAND ECONOMY": 299,
	"./pathway_illustrations/LAND ECONOMY.png": 299,
	"./pathway_illustrations/LAW": 300,
	"./pathway_illustrations/LAW.png": 300,
	"./pathway_illustrations/LIBERAL ARTS": 301,
	"./pathway_illustrations/LIBERAL ARTS.png": 301,
	"./pathway_illustrations/MANAGEMENT-BUSINESS ADMINISTRATION": 302,
	"./pathway_illustrations/MANAGEMENT-BUSINESS ADMINISTRATION.png": 302,
	"./pathway_illustrations/MARKETING": 303,
	"./pathway_illustrations/MARKETING.png": 303,
	"./pathway_illustrations/MATERIAL SCIENCE": 304,
	"./pathway_illustrations/MATERIAL SCIENCE.png": 304,
	"./pathway_illustrations/MATHEMATICS": 305,
	"./pathway_illustrations/MATHEMATICS.png": 305,
	"./pathway_illustrations/MECHANICAL ENGINEERING": 306,
	"./pathway_illustrations/MECHANICAL ENGINEERING.png": 306,
	"./pathway_illustrations/MEDICINE": 307,
	"./pathway_illustrations/MEDICINE.png": 307,
	"./pathway_illustrations/MODERN LANGUAGES": 308,
	"./pathway_illustrations/MODERN LANGUAGES.png": 308,
	"./pathway_illustrations/MORSE": 309,
	"./pathway_illustrations/MORSE.png": 309,
	"./pathway_illustrations/MUSIC": 310,
	"./pathway_illustrations/MUSIC.png": 310,
	"./pathway_illustrations/NATURAL SCIENCES": 311,
	"./pathway_illustrations/NATURAL SCIENCES.png": 311,
	"./pathway_illustrations/PARAMEDIC SCIENCE": 312,
	"./pathway_illustrations/PARAMEDIC SCIENCE.png": 312,
	"./pathway_illustrations/PHARMACOLOGY-PHARMACEUTICAL SCIENCES-MEDICINAL CHEMISTRY": 313,
	"./pathway_illustrations/PHARMACOLOGY-PHARMACEUTICAL SCIENCES-MEDICINAL CHEMISTRY.png": 313,
	"./pathway_illustrations/PHYSICS-THEORETICAL PHYSICS": 314,
	"./pathway_illustrations/PHYSICS-THEORETICAL PHYSICS.png": 314,
	"./pathway_illustrations/POLITICS-INTERNATIONAL RELATIONS": 315,
	"./pathway_illustrations/POLITICS-INTERNATIONAL RELATIONS.png": 315,
	"./pathway_illustrations/PSYCHOLOGY": 316,
	"./pathway_illustrations/PSYCHOLOGY.png": 316,
	"./pathway_illustrations/RADIOGRAPHY-MEDICAL TECHNOLOGY": 317,
	"./pathway_illustrations/RADIOGRAPHY-MEDICAL TECHNOLOGY.png": 317,
	"./pathway_illustrations/SOCIOLOGY": 318,
	"./pathway_illustrations/SOCIOLOGY.png": 318,
	"./pathway_illustrations/SPORTS SCIENCE": 319,
	"./pathway_illustrations/SPORTS SCIENCE.png": 319,
	"./pathway_illustrations/VETERINARY SCIENCE": 320,
	"./pathway_illustrations/VETERINARY SCIENCE.png": 320,
	"./pathway_illustrations/ZOOLOGY": 321,
	"./pathway_illustrations/ZOOLOGY.png": 321,
	"./pathway_illustrations/coursefinder-hero": 322,
	"./pathway_illustrations/coursefinder-hero.svg": 322,
	"./pathway_illustrations/coursefinder-mail": 323,
	"./pathway_illustrations/coursefinder-mail.svg": 323,
	"./pathway_illustrations/coursefinder-pathways": 324,
	"./pathway_illustrations/coursefinder-pathways.svg": 324,
	"./pathway_illustrations/lost": 325,
	"./pathway_illustrations/lost.jpg": 325,
	"./pathway_illustrations/pathways-deco-left": 326,
	"./pathway_illustrations/pathways-deco-left.svg": 326,
	"./pathway_illustrations/pathways-deco-right": 327,
	"./pathway_illustrations/pathways-deco-right.svg": 327,
	"./pathway_illustrations/pathways-hero": 328,
	"./pathway_illustrations/pathways-hero-02": 329,
	"./pathway_illustrations/pathways-hero-02.svg": 329,
	"./pathway_illustrations/pathways-hero-03": 330,
	"./pathway_illustrations/pathways-hero-03.svg": 330,
	"./pathway_illustrations/pathways-hero.svg": 328,
	"./pathway_illustrations/pathways-virtual-counsellor": 331,
	"./pathway_illustrations/pathways-virtual-counsellor.svg": 331,
	"./pathway_illustrations/subject-agriculture-icon": 332,
	"./pathway_illustrations/subject-agriculture-icon.svg": 332,
	"./pathway_illustrations/subject-archaeology-icon": 333,
	"./pathway_illustrations/subject-archaeology-icon.svg": 333,
	"./pathway_illustrations/subject-art-icon": 334,
	"./pathway_illustrations/subject-art-icon.svg": 334,
	"./pathway_illustrations/subject-finance-icon": 335,
	"./pathway_illustrations/subject-finance-icon.svg": 335,
	"./pathway_illustrations/subject-healthcare-icon": 336,
	"./pathway_illustrations/subject-healthcare-icon.svg": 336,
	"./pathway_illustrations/subject-languages-icon": 337,
	"./pathway_illustrations/subject-languages-icon.svg": 337,
	"./pathway_illustrations/subject-law-icon": 338,
	"./pathway_illustrations/subject-law-icon.svg": 338,
	"./pathway_illustrations/subject-music-icon": 339,
	"./pathway_illustrations/subject-music-icon.svg": 339,
	"./pathway_illustrations/subject-programming-icon": 340,
	"./pathway_illustrations/subject-programming-icon.svg": 340,
	"./pathway_illustrations/subject-science-icon": 341,
	"./pathway_illustrations/subject-science-icon.svg": 341,
	"./pathway_illustrations/universitycourse-hero": 342,
	"./pathway_illustrations/universitycourse-hero.svg": 342,
	"./starworks-logo": 343,
	"./starworks-logo.svg": 343,
	"./starworksKids-logo": 344,
	"./starworksKids-logo.svg": 344,
	"./starworksPlus-logo": 345,
	"./starworksPlus-logo.svg": 345,
	"./subject_img/ACCOUNTING-FINANCE": 346,
	"./subject_img/ACCOUNTING-FINANCE.jpg": 346,
	"./subject_img/ACTUARIAL SCIENCE": 347,
	"./subject_img/ACTUARIAL SCIENCE.jpg": 347,
	"./subject_img/AERONAUTICAL ENGINEERING": 348,
	"./subject_img/AERONAUTICAL ENGINEERING.jpg": 348,
	"./subject_img/AGRICULTURE": 349,
	"./subject_img/AGRICULTURE.jpg": 349,
	"./subject_img/ARCHITECTURE": 350,
	"./subject_img/ARCHITECTURE.jpg": 350,
	"./subject_img/ASTROPHYSICS-ASTRONOMY": 351,
	"./subject_img/ASTROPHYSICS-ASTRONOMY.jpg": 351,
	"./subject_img/BIOCHEMISTRY": 352,
	"./subject_img/BIOCHEMISTRY.jpg": 352,
	"./subject_img/BIOLOGICAL ENGINEERING-BIOMEDICAL ENGINEERING": 353,
	"./subject_img/BIOLOGICAL ENGINEERING-BIOMEDICAL ENGINEERING.jpg": 353,
	"./subject_img/BIOLOGY": 354,
	"./subject_img/BIOLOGY.jpg": 354,
	"./subject_img/BIOMEDICAL SCIENCES": 355,
	"./subject_img/BIOMEDICAL SCIENCES.jpg": 355,
	"./subject_img/BIOPHYSICS": 356,
	"./subject_img/BIOPHYSICS.jpg": 356,
	"./subject_img/CHEMICAL ENGINEERING": 357,
	"./subject_img/CHEMICAL ENGINEERING.jpg": 357,
	"./subject_img/CHEMISTRY": 358,
	"./subject_img/CHEMISTRY.jpg": 358,
	"./subject_img/CIVIL ENGINEERING": 359,
	"./subject_img/CIVIL ENGINEERING.jpg": 359,
	"./subject_img/CLASSICS-ARCHAEOLOGY": 360,
	"./subject_img/CLASSICS-ARCHAEOLOGY.jpg": 360,
	"./subject_img/COMPUTER SCIENCE-SOFTWARE ENGINEERING": 361,
	"./subject_img/COMPUTER SCIENCE-SOFTWARE ENGINEERING.jpg": 361,
	"./subject_img/CULTURAL STUDIES": 362,
	"./subject_img/CULTURAL STUDIES.jpg": 362,
	"./subject_img/DATA SCIENCE": 363,
	"./subject_img/DATA SCIENCE.jpg": 363,
	"./subject_img/DENTISTRY": 364,
	"./subject_img/DENTISTRY.jpg": 364,
	"./subject_img/DIGITAL ART": 365,
	"./subject_img/DIGITAL ART.jpg": 365,
	"./subject_img/ECONOMICS": 366,
	"./subject_img/ECONOMICS.jpg": 366,
	"./subject_img/EDUCATION": 367,
	"./subject_img/EDUCATION.jpg": 367,
	"./subject_img/ELECTRICAL-ELECTRONIC ENGINEERING": 368,
	"./subject_img/ELECTRICAL-ELECTRONIC ENGINEERING.jpg": 368,
	"./subject_img/ENGLISH LITERATURE": 369,
	"./subject_img/ENGLISH LITERATURE.jpg": 369,
	"./subject_img/FILM STUDIES-MEDIA STUDIES-CREATIVE ARTS": 370,
	"./subject_img/FILM STUDIES-MEDIA STUDIES-CREATIVE ARTS.jpg": 370,
	"./subject_img/FINE ART": 371,
	"./subject_img/FINE ART.jpg": 371,
	"./subject_img/GENERAL ENGINEERING": 372,
	"./subject_img/GENERAL ENGINEERING.jpg": 372,
	"./subject_img/GEOGRAPHY": 373,
	"./subject_img/GEOGRAPHY.jpg": 373,
	"./subject_img/GEOLOGY-EARTH SCIENCES": 374,
	"./subject_img/GEOLOGY-EARTH SCIENCES.jpg": 374,
	"./subject_img/HISTORY": 375,
	"./subject_img/HISTORY OF ART": 376,
	"./subject_img/HISTORY OF ART.jpg": 376,
	"./subject_img/HISTORY.jpg": 375,
	"./subject_img/HUMAN SCIENCES-ANTHROPOLOGY": 377,
	"./subject_img/HUMAN SCIENCES-ANTHROPOLOGY.jpg": 377,
	"./subject_img/JOINT HONOURS": 378,
	"./subject_img/JOINT HONOURS.jpg": 378,
	"./subject_img/JOURNALISM": 379,
	"./subject_img/JOURNALISM.jpg": 379,
	"./subject_img/LAND ECONOMY": 380,
	"./subject_img/LAND ECONOMY.jpg": 380,
	"./subject_img/LAW": 381,
	"./subject_img/LAW.jpg": 381,
	"./subject_img/LIBERAL ARTS": 382,
	"./subject_img/LIBERAL ARTS.jpg": 382,
	"./subject_img/MANAGEMENT-BUSINESS ADMINISTRATION": 383,
	"./subject_img/MANAGEMENT-BUSINESS ADMINISTRATION.jpg": 383,
	"./subject_img/MARKETING": 384,
	"./subject_img/MARKETING.jpg": 384,
	"./subject_img/MATERIAL SCIENCE": 385,
	"./subject_img/MATERIAL SCIENCE.jpg": 385,
	"./subject_img/MATHEMATICS": 386,
	"./subject_img/MATHEMATICS.jpg": 386,
	"./subject_img/MECHANICAL ENGINEERING": 387,
	"./subject_img/MECHANICAL ENGINEERING.jpg": 387,
	"./subject_img/MEDICINE": 388,
	"./subject_img/MEDICINE.jpg": 388,
	"./subject_img/MODERN LANGUAGES": 389,
	"./subject_img/MODERN LANGUAGES.jpg": 389,
	"./subject_img/MORSE": 390,
	"./subject_img/MORSE.jpg": 390,
	"./subject_img/MUSIC": 391,
	"./subject_img/MUSIC.jpg": 391,
	"./subject_img/NATURAL SCIENCES": 392,
	"./subject_img/NATURAL SCIENCES.jpg": 392,
	"./subject_img/PARAMEDIC SCIENCE": 393,
	"./subject_img/PARAMEDIC SCIENCE.jpg": 393,
	"./subject_img/PHARMACOLOGY-PHARMACEUTICAL SCIENCES-MEDICINAL CHEMISTRY": 394,
	"./subject_img/PHARMACOLOGY-PHARMACEUTICAL SCIENCES-MEDICINAL CHEMISTRY.jpg": 394,
	"./subject_img/PHILOSOPHY": 395,
	"./subject_img/PHILOSOPHY.jpg": 395,
	"./subject_img/PHYSICS-THEORETICAL PHYSICS": 396,
	"./subject_img/PHYSICS-THEORETICAL PHYSICS.jpg": 396,
	"./subject_img/POLITICS-INTERNATIONAL RELATIONS": 397,
	"./subject_img/POLITICS-INTERNATIONAL RELATIONS.jpg": 397,
	"./subject_img/PSYCHOLOGY": 398,
	"./subject_img/PSYCHOLOGY.jpg": 398,
	"./subject_img/RADIOGRAPHY-MEDICAL TECHNOLOGY": 399,
	"./subject_img/RADIOGRAPHY-MEDICAL TECHNOLOGY.jpg": 399,
	"./subject_img/SOCIOLOGY": 400,
	"./subject_img/SOCIOLOGY.jpg": 400,
	"./subject_img/SPORTS SCIENCE": 401,
	"./subject_img/SPORTS SCIENCE.jpg": 401,
	"./subject_img/VETERINARY SCIENCE": 402,
	"./subject_img/VETERINARY SCIENCE.jpg": 402,
	"./subject_img/ZOOLOGY": 403,
	"./subject_img/ZOOLOGY.jpg": 403,
	"./sw-logo-light": 404,
	"./sw-logo-light.svg": 404,
	"./swPlus-logo-light": 405,
	"./swPlus-logo-light.svg": 405,
	"./tutors/PrepWorks-Aidan-Chan": 406,
	"./tutors/PrepWorks-Aidan-Chan.jpg": 406,
	"./tutors/PrepWorks-Celine-Wan": 407,
	"./tutors/PrepWorks-Celine-Wan.jpg": 407,
	"./tutors/PrepWorks-Jesryna": 408,
	"./tutors/PrepWorks-Jesryna.jpg": 408,
	"./tutors/PrepWorks-Lakshan": 409,
	"./tutors/PrepWorks-Lakshan.jpg": 409,
	"./tutors/PrepWorks-Nadia-Crowe": 410,
	"./tutors/PrepWorks-Nadia-Crowe.jpg": 410,
	"./tutors/PrepWorks-Pheng-Chew": 411,
	"./tutors/PrepWorks-Pheng-Chew.jpg": 411,
	"./tutors/PrepWorks-Salman": 412,
	"./tutors/PrepWorks-Salman.jpg": 412,
	"./tutors/PrepWorks-Sarah-Choo": 413,
	"./tutors/PrepWorks-Sarah-Choo.jpg": 413,
	"./tutors/PrepWorks-Sarah-Yeoh": 414,
	"./tutors/PrepWorks-Sarah-Yeoh.jpg": 414,
	"./tutors/PrepWorks-Tamara-Lim": 415,
	"./tutors/PrepWorks-Tamara-Lim.jpg": 415,
	"./tutors/PrepWorks-Yee-Wan-Ting": 416,
	"./tutors/PrepWorks-Yee-Wan-Ting.jpg": 416,
	"./tutors/PrepWorks-Yu-Han": 417,
	"./tutors/PrepWorks-Yu-Han.jpg": 417,
	"./university_logos/Architectural-Association-School-of-Architecture": 418,
	"./university_logos/Architectural-Association-School-of-Architecture.svg": 418,
	"./university_logos/Canterbury-University": 419,
	"./university_logos/Canterbury-University.svg": 419,
	"./university_logos/Cardiff-University": 420,
	"./university_logos/Cardiff-University.svg": 420,
	"./university_logos/Durham-University": 421,
	"./university_logos/Durham-University.svg": 421,
	"./university_logos/Imperial-College-of-London": 422,
	"./university_logos/Imperial-College-of-London.svg": 422,
	"./university_logos/Keele-University": 423,
	"./university_logos/Keele-University.svg": 423,
	"./university_logos/Kings-College-London": 424,
	"./university_logos/Kings-College-London.svg": 424,
	"./university_logos/London-School-of-Economics": 425,
	"./university_logos/London-School-of-Economics.svg": 425,
	"./university_logos/Loughborough-University": 426,
	"./university_logos/Loughborough-University.svg": 426,
	"./university_logos/Manchester-Metropolitan-University": 427,
	"./university_logos/Manchester-Metropolitan-University.svg": 427,
	"./university_logos/Newcastle-University": 428,
	"./university_logos/Newcastle-University.svg": 428,
	"./university_logos/Queen-Mary-University-of-London": 429,
	"./university_logos/Queen-Mary-University-of-London.svg": 429,
	"./university_logos/Queens-University-Belfast": 430,
	"./university_logos/Queens-University-Belfast.svg": 430,
	"./university_logos/SOAS-University-of-London": 431,
	"./university_logos/SOAS-University-of-London.svg": 431,
	"./university_logos/St-Georges-University-of-London": 432,
	"./university_logos/St-Georges-University-of-London.svg": 432,
	"./university_logos/University-College-London": 433,
	"./university_logos/University-College-London.svg": 433,
	"./university_logos/University-of-Aberdeen": 434,
	"./university_logos/University-of-Aberdeen.svg": 434,
	"./university_logos/University-of-Bath": 435,
	"./university_logos/University-of-Bath.svg": 435,
	"./university_logos/University-of-Birmingham": 436,
	"./university_logos/University-of-Birmingham.svg": 436,
	"./university_logos/University-of-Bristol": 437,
	"./university_logos/University-of-Bristol.svg": 437,
	"./university_logos/University-of-Cambridge": 438,
	"./university_logos/University-of-Cambridge.svg": 438,
	"./university_logos/University-of-Dundee": 439,
	"./university_logos/University-of-Dundee.svg": 439,
	"./university_logos/University-of-Edinburgh": 440,
	"./university_logos/University-of-Edinburgh.svg": 440,
	"./university_logos/University-of-Exeter": 441,
	"./university_logos/University-of-Exeter.svg": 441,
	"./university_logos/University-of-Glasgow": 442,
	"./university_logos/University-of-Glasgow.svg": 442,
	"./university_logos/University-of-Lancaster": 443,
	"./university_logos/University-of-Lancaster.svg": 443,
	"./university_logos/University-of-Leeds": 444,
	"./university_logos/University-of-Leeds.svg": 444,
	"./university_logos/University-of-Liverpool": 445,
	"./university_logos/University-of-Liverpool.svg": 445,
	"./university_logos/University-of-Manchester": 446,
	"./university_logos/University-of-Manchester.svg": 446,
	"./university_logos/University-of-Nottingham": 447,
	"./university_logos/University-of-Nottingham.svg": 447,
	"./university_logos/University-of-Oxford": 448,
	"./university_logos/University-of-Oxford.svg": 448,
	"./university_logos/University-of-Plymouth": 449,
	"./university_logos/University-of-Plymouth.svg": 449,
	"./university_logos/University-of-Sheffield": 450,
	"./university_logos/University-of-Sheffield.svg": 450,
	"./university_logos/University-of-Southampton": 451,
	"./university_logos/University-of-Southampton.svg": 451,
	"./university_logos/University-of-St-Andrews": 452,
	"./university_logos/University-of-St-Andrews.svg": 452,
	"./university_logos/University-of-Surrey": 453,
	"./university_logos/University-of-Surrey.svg": 453,
	"./university_logos/University-of-Warwick": 454,
	"./university_logos/University-of-Warwick.svg": 454,
	"./university_logos/University-of-York": 455,
	"./university_logos/University-of-York.svg": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;